import { ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import BaseEntitiesSearchAutocomplete, {
  BaseEntitiesSearchAutocompleteInheritableProps,
} from "@/common/components/Entity/components/BaseEntitiesSearchAutocomplete";
import AppIcon from "@/common/components/Icons/AppIcon";
import { renderIf } from "@/common/helpers/render/renderIf";
import { AutocompleteOptionType } from "@/common/ts/autocomplete";
import { apiClient } from "@/core/api/ApiClient";
import { AssetSubscriptionDto, AssetSubscriptionGetPaginatedDto } from "@/core/api/generated/v1";

import { assetSubscriptionToOption } from "./AssetSubscriptionAutocomplete";

export interface AssetSubscriptionsAutocompleteProps extends BaseEntitiesSearchAutocompleteInheritableProps<AssetSubscriptionDto> {
  searchFilters?: Partial<Omit<AssetSubscriptionGetPaginatedDto, "search" | "includeIds">>;
}

export default function AssetSubscriptionsAutocomplete({
  searchFilters,

  isPreload = true,
  ...otherProps
}: AssetSubscriptionsAutocompleteProps) {
  return (
    <BaseEntitiesSearchAutocomplete
      sx={{ minWidth: 200, flex: 1 }}
      entityToOption={assetSubscriptionToOption}
      isPreload={isPreload}
      request={{
        requestFunc: apiClient.assetSubscriptionsApi.apiV1AssetSubscriptionsGetPost,
        limit: 25,
        parameters: {
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          assetSubscriptionGetPaginatedDto: {
            ...searchFilters,
          },
        },
        combineParameters: (params, newParams) => ({
          ...params,
          assetSubscriptionGetPaginatedDto: {
            ...params.assetSubscriptionGetPaginatedDto,
            ...newParams,
          },
        }),
        deps: [searchFilters],
      }}
      label='AssetSubscriptions'
      placeholder='Search for assetSubscriptions...'
      renderOption={(props, option) => {
        return (
          <ListItem {...props}>
            <ListItemIcon>
              {renderIf()
                .if(option.optionType === AutocompleteOptionType.Normal)
                .then(<AppIcon of='assetSubscription' />)
                .elseif(option.optionType === AutocompleteOptionType.DynamicCreateNew)
                .then(<AppIcon of='add' />)
                .render()}
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Typography
                    variant={
                      option.optionType === AutocompleteOptionType.DynamicCreateNew
                        ? "subtitle1"
                        : "body1"
                    }
                    component='div'
                  >
                    {option.title}
                  </Typography>
                  {option.data && <Typography component='div' variant='body2'></Typography>}
                </>
              }
            />
          </ListItem>
        );
      }}
      {...otherProps}
    />
  );
}
